var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-main"},[_c('div',{staticClass:"site-content"},[_c('router-view')],1),_c('AlarmNotify',{on:{"shown":_vm.showAlarmList}}),_c('ModalList',{model:{value:(_vm.showAlarmModal),callback:function ($$v) {_vm.showAlarmModal=$$v},expression:"showAlarmModal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }